import { useNotification } from '../../context/NotificationContext';
import '../../styles/toast-notifications.css';

const Notifications = () => {
  const { notifications, removeNotification } = useNotification();

  // Si no hay notificaciones, no renderizar nada
  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className="toast-notifications-container">
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={`toast-notification toast-notification-${notification.type}`}
        >
          <div className="toast-notification-header">
            <h3 className="toast-notification-title">{notification.title}</h3>
            <button
              className="toast-notification-close"
              onClick={() => removeNotification(notification.id)}
              aria-label="Cerrar"
            >
              <span className="material-icons">close</span>
            </button>
          </div>
          <div className="toast-notification-body">
            <p className="toast-notification-message">{notification.message}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Notifications;
